import React from "react";
import styles from "./WhatsAppFloat.module.css";

const WHATSAPP_NUMBER = "971567575811";

function WhatsAppFloat() {
  const link = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hi Tripontourism! I'm interested in booking a Desert Safari."
  )}`;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.floatBtn}
      aria-label="Chat with us on WhatsApp"
    >
      <span className={styles.pulse}></span>
      <span className={styles.icon} aria-hidden="true">
        💬
      </span>
    </a>
  );
}

export default WhatsAppFloat;
